/**
 * PF v2 native modules — pure completeness-predicate map (A-01).
 *
 * The ONLY thing `store/selectors.ts` needs from the module layer is each flow's
 * completeness predicate. Keeping that map here — with ZERO React / store /
 * component imports — lets the store import it without dragging JSX into the
 * store layer and without the cycle
 * `store/index → selectors → registry → components → store`.
 *
 * `store/registry.ts` (the JSX component map) is the OTHER half of the A-01 split
 * and must NEVER be imported by the store layer.
 *
 * All 9 flows are now native, so every flow has a predicate here and
 * `selectFlowComplete` (store/selectors.ts) always resolves to one — the legacy
 * `cartItemIsComplete` mirror fallback was deleted in the Wave-3 teardown.
 */

import type { ConfigOutputDTO, ConfigurationFlowId } from 'models/purchaseFlowRevamp'

import { measurementIsComplete } from './measurement/measurement.dto'
import { floorPlanCertIsComplete } from './floorPlanCertification/floorPlanCertification.dto'
import { propertyInfoIsComplete } from './propertyInfo/propertyInfo.dto'
import { powerOfAttorneyIsComplete } from './powerOfAttorney/powerOfAttorney.dto'
import { consumptionCertificateIsComplete } from './consumptionCertificate/consumptionCertificate.dto'
import { energyCertificateIsComplete } from './energyCertificateOfNeed/energyCertificateOfNeed.dto'
import { floorPlanConfigIsComplete } from './floorPlanConfig/floorPlanConfig.dto'
import { stagingIsComplete } from './staging/staging.dto'
import { editingConfigIsComplete } from './editingConfig/editingConfig.dto'

export const FLOW_IS_COMPLETE: Partial<
  Record<ConfigurationFlowId, (dto: ConfigOutputDTO | undefined) => boolean>
> = {
  measurement: measurementIsComplete as (dto: ConfigOutputDTO | undefined) => boolean,
  floor_plan_certification: floorPlanCertIsComplete as (dto: ConfigOutputDTO | undefined) => boolean,
  property_info: propertyInfoIsComplete as (dto: ConfigOutputDTO | undefined) => boolean,
  power_of_attorney: powerOfAttorneyIsComplete as (dto: ConfigOutputDTO | undefined) => boolean,
  consumption_certificate: consumptionCertificateIsComplete as (dto: ConfigOutputDTO | undefined) => boolean,
  energy_certificate_of_need: energyCertificateIsComplete as (dto: ConfigOutputDTO | undefined) => boolean,
  floor_plan_config: floorPlanConfigIsComplete as (dto: ConfigOutputDTO | undefined) => boolean,
  staging: stagingIsComplete as (dto: ConfigOutputDTO | undefined) => boolean,
  editing_config: editingConfigIsComplete as (dto: ConfigOutputDTO | undefined) => boolean,
}
